/**
 * The current version of the user terms ("Brukervilkår for Zuprize").
 *
 * CommonJS, so the server can read it as well as the app: sign-up stores it
 * in privateData.termsAcceptance.version (src/util/termsAcceptance.js), and the
 * member notice (server/api/admin/terms-notice.js) skips anyone who accepted
 * this version at sign-up, since the notice is about changing to it.
 */
const TERMS_VERSION = '21';

module.exports = { TERMS_VERSION };
